import { ApolloError, useQuery } from '@apollo/client'
import type { PublicProfileCollection } from 'apollo-gql'
import { currentLanguageIdVar, currentMarketIdVar } from 'graphql/reactive'

import { GET_PAGE } from 'hooks/usePage'

export default function useTrending(): {
  trendingCollection: PublicProfileCollection
  loading: boolean
  error: ApolloError
} {
  const slug = 'home'
  const marketId = currentMarketIdVar()
  const languageId = currentLanguageIdVar()

  const { loading, data, error } = useQuery(GET_PAGE, {
    variables: {
      slug,
      marketId,
      languageId,
    },
    returnPartialData: true,
  })
  const page = data.market && data.market.page
  const trendingCollection = page?.publicCmsItems[1]?.profileCollection

  return { trendingCollection, loading, error }
}
